import { useAppDispatch, useAppSelector } from 'flow/hooks/useRedux';
import React, { useEffect, useState } from 'react';

import { fetchTicketsAllLatest } from 'flow/actions/tickets-action';
import TicketsIntroView from 'flow/components/tickets/TicketsIntroView';
import { selectIsAdmin } from 'flow/selectors/own-extension-selectors';
import { selectUserIsMemberOfSomeTicket } from 'flow/selectors/TicketsSelectors';

const LandingPageTickets = () => {
    const dispatch = useAppDispatch<any>();
    const userIsMemberOfSomeTicket = useAppSelector(
        selectUserIsMemberOfSomeTicket,
    );
    const isAdmin = useAppSelector(selectIsAdmin);

    const [shouldDisplayIntroView, setShouldDisplayIntroView] = useState(false);

    useEffect(() => {
        if (userIsMemberOfSomeTicket) {
            setShouldDisplayIntroView(false);
        } else {
            dispatch(fetchTicketsAllLatest).then((data?: []) => {
                if (!data || data.length === 0) {
                    setShouldDisplayIntroView(true);
                }
            });
        }
    }, [dispatch, userIsMemberOfSomeTicket]);

    return shouldDisplayIntroView ? (
        <TicketsIntroView messageIsAdaptedToNonAdminUser={!isAdmin} />
    ) : (
        <div className="h-full w-full bg-white" />
    );
};

export default React.memo(LandingPageTickets);
